import api from "./api";

const CaseLog = "case/getAll";
const CasesBetweenDates = "case/getBetweenDates";
const CasesByDescription = "case/getByDescription";
const LastCaseNumber = "case/getLastID";

const AddCase = "case/add";
const EditCase = "case/edit";
const DeleteCase = "case/delete";

const getAll = () => api.get(CaseLog);

const getCasesBetweenDates = (startDate, endDate) =>
  api.get(CasesBetweenDates, { startDate, endDate });

const getCasesByDescription = (description) =>
  api.get(CasesByDescription, { description });

const getLastCaseNumber = () => api.get(LastCaseNumber);

const add = (model) => api.post(AddCase, model);
const edit = (model) => api.put(EditCase, model);

const del = (id) => api.delete(DeleteCase, { id });

const caseLogService = {
  getAll,
  getCasesBetweenDates,
  getCasesByDescription,
  getLastCaseNumber,
  add,
  edit,
  del,
};
export default caseLogService;
